import { render, staticRenderFns } from "./BTZPendingTransfers.vue?vue&type=template&id=c148ff00&lang=pug"
import script from "./BTZPendingTransfers.vue?vue&type=script&lang=js"
export * from "./BTZPendingTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports